var path = '/payments/failure/failure.html';
var html = "<md-card class=has-circle-icon> <md-card-content class=only-buttons> <div layout=row> <h3>Payment failure</h3> </div> <div layout=row class=user-message layout-align=center data-test-id=accounts_payments_failure_message> Sorry, we couldn't process your payment. Check your payment details and try again. </div> </md-card-content> <div layout=row layout-align=center> <md-button data-test-id=accounts_payments_failure_done class=\"md-primary md-raised center\" ng-click=failure.next()> TRY AGAIN </md-button> </div> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./payments/failure/failure.html
// module id = 277
// module chunks = 0